// removed by extract-text-webpack-plugin
module.exports = {"reportIcon":"reportIcon__1sL5A6N5wtgo"};